// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Data11 from "common/src/data/Data11.bs.js";
import * as Data13 from "common/src/data/Data13.bs.js";
import * as Data14 from "common/src/data/Data14.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as SupSection from "./SupSection.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as SupUnitCard from "./SupUnitCard.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as UnitInfoPage from "../info/UnitInfoPage.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

function SupUnits$Itemization(Props) {
  var typ = Props.typ;
  var t = Translation.useT(/* Common */0);
  var items = Dict.getExn(Data13.data.itemization, typ);
  return React.createElement(Tooltip.make, {
              title: React.createElement("div", undefined, React.createElement("div", {
                        className: "font-montserrat font-medium text-[15px] pb-2"
                      }, t(typ) + " Items"), React.createElement("div", {
                        className: "grid grid-cols-4 gap-2"
                      }, Belt_Array.map(items, (function (itemId) {
                              return React.createElement(ItemImage.make, {
                                          itemId: itemId,
                                          size: 32,
                                          rounded: "rounded",
                                          key: itemId
                                        });
                            })))),
              children: React.createElement("div", {
                    className: "bg-bg2 rounded-lg px-2 py-1 font-montserrat font-medium self-start"
                  }, t(typ))
            });
}

var Itemization = {
  make: SupUnits$Itemization
};

function SupUnits$UnitAbilityInfo(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  TftSet.use(undefined);
  var unitsT = Translation.useT(/* Units */1);
  var basePath = CdnAtom.usePath(undefined);
  var basePath3 = CdnAtom.usePath4(undefined);
  var match = React.useState(function () {
        return false;
      });
  var setUsePlaceholder = match[1];
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex items-center mt-1 mb-2"
                }, React.createElement("img", {
                      className: "rounded flex-shrink-0 w-[22px] h-[22px]",
                      height: "22",
                      src: match[0] ? basePath3 + "/items_s10/_.jpg?w=22" : basePath3 + "/cd14/ability/" + unitId + ".png?w=22",
                      width: "22",
                      onError: (function (param) {
                          return Curry._1(setUsePlaceholder, (function (param) {
                                        return true;
                                      }));
                        })
                    }), React.createElement("div", {
                      className: "flex items-center pl-2 leading-none"
                    }, React.createElement("div", {
                          className: "font-medium text-sm"
                        }, unitId === "TFT9_Ryze" ? "Realm Warp" : unitsT(unitId + "_ability")), info.stats.mana > 0 ? React.createElement("div", {
                            className: "flex items-center pt-[2px] h-[18px] text-sm pl-2"
                          }, React.createElement("div", {
                                className: "mt-[-1px] mr-[2px] w-[14px] h-[14px]"
                              }, React.createElement("img", {
                                    alt: "Mana",
                                    height: "14",
                                    src: basePath + "/general/mana.png",
                                    width: "14"
                                  })), React.createElement("div", {
                                className: "pt-[1px]"
                              }, String(info.stats.initialMana) + "/" + String(info.stats.mana))) : null)), React.createElement(RitoDescription2.make, {
                  desc: unitsT(unitId + "_desc")
                }), React.createElement(UnitTooltip.AbilityDetails.make, {
                  unitId: unitId,
                  info: info
                }));
}

var UnitAbilityInfo = {
  make: SupUnits$UnitAbilityInfo
};

function SupUnits$UnitAbility(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  Translation.useT(/* Common */0);
  var basePath = CdnAtom.usePath(undefined);
  CdnAtom.usePath4(undefined);
  var itemization = info.itemization;
  var tmp;
  if (unitId === "TFT11_Rakan" || unitId === "TFT11_Xayah") {
    var dummyId = unitId === "TFT11_Rakan" ? "TFT11_XayahBenchDummy" : "TFT11_RakanBenchDummy";
    var dummyInfo = Dict.getExn(Data11.units, dummyId);
    tmp = React.createElement("div", {
          className: "mt-8"
        }, React.createElement(SupUnits$UnitAbilityInfo, {
              unitId: dummyId,
              info: dummyInfo
            }));
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "p-3 flex flex-col text-sm"
            }, React.createElement("div", {
                  className: "flex items-center justify-between mb-2"
                }, itemization !== undefined ? React.createElement(SupUnits$Itemization, {
                        typ: itemization
                      }) : null, React.createElement("div", {
                      className: "flex items-center gap-[2px]"
                    }, React.createElement("div", {
                          className: "flex-shrink-0"
                        }, React.createElement("img", {
                              title: "Range",
                              alt: "Range",
                              height: "14",
                              src: basePath + "/general/range.png",
                              width: "14"
                            })), React.createElement("div", {
                          className: "pl-1 font-montserrat text-lg font-medium text-white1 break-all"
                        }, String(info.stats.range)))), React.createElement(SupUnits$UnitAbilityInfo, {
                  unitId: unitId,
                  info: info
                }), tmp);
}

var UnitAbility = {
  make: SupUnits$UnitAbility
};

function SupUnits$UnitTraits(Props) {
  var unitId = Props.unitId;
  var traitsT = Translation.useT(/* Traits */2);
  var set = TftSet.use(undefined);
  var traits = Sd.getUnitTraits(unitId, set);
  return React.createElement("div", {
              className: "p-3 flex flex-col gap-4"
            }, Belt_Array.map(traits, (function (traitId) {
                    return React.createElement("div", {
                                key: traitId,
                                className: "text-sm"
                              }, React.createElement("div", {
                                    className: "flex items-center gap-[2px] pb-[6px]"
                                  }, React.createElement(TraitImage.PlainIcon.make, {
                                        traitId: traitId,
                                        size: 22
                                      }), React.createElement("h3", {
                                        className: "inline-block text-base font-montserrat font-medium"
                                      }, traitsT(traitId))), React.createElement(RitoDescription2.make, {
                                    desc: traitsT(traitId + "_desc")
                                  }));
                  })));
}

var UnitTraits = {
  make: SupUnits$UnitTraits
};

function SupUnits$UnitStats(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  return React.createElement("div", {
              className: "py-3 px-4"
            }, React.createElement(UnitInfoPage.StatsGrid.make, {
                  unitId: unitId,
                  info: info
                }));
}

var UnitStats = {
  make: SupUnits$UnitStats
};

function SupUnits$Upgrade(Props) {
  var itemId = Props.itemId;
  var t = Translation.useT(/* Items */3);
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "flex items-center gap-2 pb-1"
                }, React.createElement(ItemImage.make, {
                      itemId: itemId,
                      size: 26
                    }), React.createElement("div", undefined, t(Data.encodeItemId(itemId)))), React.createElement("div", {
                  className: "text-sm leading-tight"
                }, React.createElement(RitoDescription2.make, {
                      desc: t(Data.encodeItemId(itemId + "_desc"))
                    })));
}

var Upgrade = {
  make: SupUnits$Upgrade
};

function SupUnits$UnitCard(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        return /* Ability */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var traits = Sd.getUnitTraits(unitId, set);
  var tmp;
  switch (tab) {
    case /* Ability */0 :
        tmp = React.createElement(SupUnits$UnitAbility, {
              unitId: unitId,
              info: info
            });
        break;
    case /* Traits */1 :
        tmp = unitId === "TFT11_Kayle" ? React.createElement("div", {
                className: "p-4 flex flex-col gap-2"
              }, React.createElement("h3", {
                    className: "h3 pt-0 pb-1"
                  }, "Level 1 Effect Options"), React.createElement(SupUnits$Upgrade, {
                    itemId: "TFT11_Storyweaver3_AS"
                  }), React.createElement(SupUnits$Upgrade, {
                    itemId: "TFT11_Storyweaver3_AP"
                  }), React.createElement(SupUnits$Upgrade, {
                    itemId: "TFT11_Storyweaver3_Support"
                  }), React.createElement("h3", {
                    className: "h3 pt-4 pb-1"
                  }, "Level 2 Effect Options"), React.createElement(SupUnits$Upgrade, {
                    itemId: "TFT11_Storyweaver5_AS"
                  }), React.createElement(SupUnits$Upgrade, {
                    itemId: "TFT11_Storyweaver5_AP"
                  }), React.createElement("h3", {
                    className: "h3 pt-4 pb-1"
                  }, "Level 3 Effect Options"), React.createElement(SupUnits$Upgrade, {
                    itemId: "TFT11_Storyweaver7_AS"
                  }), React.createElement(SupUnits$Upgrade, {
                    itemId: "TFT11_Storyweaver7_Support"
                  })) : React.createElement(SupUnits$UnitTraits, {
                unitId: unitId
              });
        break;
    case /* Stats */2 :
        tmp = React.createElement(SupUnits$UnitStats, {
              unitId: unitId,
              info: info
            });
        break;
    
  }
  return React.createElement(ContentSection.make, {
              className: "w-[291px] flex flex-col",
              children: null,
              noPadding: true
            }, React.createElement(SupUnitCard.make, {
                  unitId: unitId,
                  traits: traits,
                  width: 290
                }), tmp, React.createElement(Tabs, {
                  classes: {
                    root: "mt-auto"
                  },
                  children: null,
                  value: tab,
                  onChange: (function (param, t) {
                      return Curry._1(setTab, (function (param) {
                                    return t;
                                  }));
                    })
                }, React.createElement(Tab, {
                      label: "Ability",
                      value: /* Ability */0,
                      classes: {
                        root: "min-w-[97px]"
                      }
                    }), React.createElement(Tab, {
                      label: "Stats",
                      value: /* Stats */2,
                      classes: {
                        root: "min-w-[97px]"
                      }
                    }), React.createElement(Tab, {
                      label: unitId === "TFT11_Kayle" ? "Effects" : "Traits",
                      value: /* Traits */1,
                      classes: {
                        root: "min-w-[97px]"
                      }
                    })));
}

var UnitCard = {
  make: SupUnits$UnitCard
};

function SupUnits(Props) {
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var units = Sd.allUnits(set);
  ScreenAtom.use(undefined);
  var units1 = React.useMemo(function () {
        return Belt_Array.keep(units, (function (unitId) {
                      return Sd.unitTier(unitId) === 1;
                    }));
      });
  var units2 = React.useMemo(function () {
        return Belt_Array.keep(units, (function (unitId) {
                      return Sd.unitTier(unitId) === 2;
                    }));
      });
  var units3 = React.useMemo(function () {
        return Belt_Array.keep(units, (function (unitId) {
                      return Sd.unitTier(unitId) === 3;
                    }));
      });
  var units4 = React.useMemo(function () {
        return Belt_Array.keep(units, (function (unitId) {
                      return Sd.unitTier(unitId) === 4;
                    }));
      });
  var units5 = React.useMemo(function () {
        return Belt_Array.keep(units, (function (unitId) {
                      return Sd.unitTier(unitId) === 5;
                    }));
      });
  var mapFn = function (unitId) {
    if (Sd.getUnitTraits(unitId, set).includes("TFT13_FormSwapper")) {
      return React.createElement("div", undefined);
    } else {
      return React.createElement(SupUnits$UnitCard, {
                  unitId: unitId,
                  info: Dict.getExn(Data14.units, unitId),
                  key: unitId
                });
    }
  };
  return React.createElement(SupSection.make, {
              children: null,
              id: "set-update-units",
              title: t("Units")
            }, React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
                }, Belt_Array.map(units1, mapFn)), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 pt-20"
                }, Belt_Array.map(units2, mapFn)), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 pt-20"
                }, Belt_Array.map(units3, mapFn)), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 pt-20"
                }, Belt_Array.map(units4, mapFn)), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 pt-20"
                }, Belt_Array.map(units5, mapFn)), React.createElement("div", undefined));
}

var make = SupUnits;

export {
  Itemization ,
  UnitAbilityInfo ,
  UnitAbility ,
  UnitTraits ,
  UnitStats ,
  Upgrade ,
  UnitCard ,
  make ,
  
}
/* Sd Not a pure module */
